import { render } from "./card-type.vue?vue&type=template&id=4c6f8f50&scoped=true"
import script from "./card-type.vue?vue&type=script&lang=js"
export * from "./card-type.vue?vue&type=script&lang=js"

import "./card-type.vue?vue&type=style&index=0&id=4c6f8f50&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6f8f50"]])

export default __exports__